import React from 'react'

// Kebab popover shared by the list row. Closes on outside click. Actions are
// passed in from the container so the row and detail panel share one action set.
const ArRowMenu = ({ company, actions, onClose }) => {
  const ref = React.useRef(null)

  React.useEffect(() => {
    const onDocClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) onClose()
    }
    document.addEventListener('mousedown', onDocClick)
    return () => document.removeEventListener('mousedown', onDocClick)
  }, [onClose])

  return (
    <div className="ar-menu" ref={ref} role="menu">
      {actions.map((action, index) => (
        <button
          key={index}
          type="button"
          className={`ar-menu-item ${action.tone ? `tone-${action.tone}` : ''}`}
          disabled={action.disabled}
          onClick={() => { onClose(); action.run(company) }}
        >{action.label}</button>
      ))}
    </div>
  )
}

export default ArRowMenu
